import { Record } from "immutable";

export type VocabularyWordStatType = {
  sessionsCompleted?: number;
  totalStudyTime?: number;
  averageScore?: number;
  lastScore?: number;
  firstScore?: number;
  bestScore?: number;
  worstScore?: number;
};

export const defaultVocabularyWordStat: VocabularyWordStatType = {
  sessionsCompleted: undefined,
  totalStudyTime: undefined,
  averageScore: undefined,
  lastScore: undefined,
  firstScore: undefined,
  bestScore: undefined,
  worstScore: undefined
};

export default class VocabularyWordStat extends Record(
  defaultVocabularyWordStat
) {}
